'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _utilsString = require('@bibliocommons/utils-string');

var _expandButton = require('../../expand-button');

var _expandButton2 = _interopRequireDefault(_expandButton);

require('../styles/ExpandableText.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandableText = function (_BcReactComponent) {
  _inherits(ExpandableText, _BcReactComponent);

  function ExpandableText(props) {
    _classCallCheck(this, ExpandableText);

    var _this = _possibleConstructorReturn(this, (ExpandableText.__proto__ || Object.getPrototypeOf(ExpandableText)).call(this, props));

    _this.bindAll('handleToggle');

    _this.state = {
      expanded: false
    };
    return _this;
  }

  _createClass(ExpandableText, [{
    key: 'handleToggle',
    value: function handleToggle() {
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: 'renderExpandButton',
    value: function renderExpandButton() {
      return _react2.default.createElement(_expandButton2.default, { handleToggle: this.handleToggle, expanded: this.state.expanded });
    }
  }, {
    key: 'renderExpandedText',
    value: function renderExpandedText() {
      var text = this.props.text;
      var expanded = this.state.expanded;


      return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('expanded-text', { 'sr-only': !expanded }) },
        text
      );
    }
  }, {
    key: 'renderTruncatedText',
    value: function renderTruncatedText(truncatedText) {
      if (this.state.expanded) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { className: 'truncated-text', 'aria-hidden': true },
        truncatedText
      );
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props = this.props,
          text = _props.text,
          truncateCount = _props.truncateCount;

      var truncatedText = (0, _utilsString.truncate)(text, { desiredLength: truncateCount });

      if (text.length > truncatedText.length) {
        return _react2.default.createElement(
          'span',
          null,
          this.renderExpandedText(),
          this.renderTruncatedText(truncatedText),
          this.renderExpandButton()
        );
      }

      return _react2.default.createElement(
        'span',
        null,
        text
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('cp-expandable-text', this.props.className) },
        this.renderContent()
      );
    }
  }]);

  return ExpandableText;
}(_baseBcReactComponent2.default);

exports.default = ExpandableText;


ExpandableText.propTypes = {
  text: _react.PropTypes.string.isRequired,
  truncateCount: _react.PropTypes.number,
  className: _react.PropTypes.string
};

ExpandableText.defaultProps = {
  truncateCount: 250
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/expandable/lib/components/expandable-text/components/ExpandableText.component.js
// module id = 1412
// module chunks = 1